import styled from 'styled-components';
import { List as antdList } from 'antd';

export const List = styled(antdList)`
    .ant-list-item, .ant-list-item-meta-content h4 {
        font-size: ${({ theme }) => `${14 + 2 * theme.zoomFonte}px`};
    }
`;